<template>
  <v-container>
    <v-card>
      <v-container>
        <v-tabs v-model="tab">
          <v-tab>{{ $t("company.tabs.administrators.title") }}</v-tab>
          <v-tab v-if="company.id != 'OaaRuxV6tA3nobp42xMq'">{{
            $t("company.tabs.branding.title")
          }}</v-tab>
          <v-tab v-if="companyPrivate != null">{{ $t("company.tabs.payments.title") }}</v-tab>
          <!-- <v-tab>{{ $t("common.trips") }}</v-tab> -->
        </v-tabs>
        <v-divider></v-divider>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <Administrators :companyId="company.id" />
          </v-tab-item>
          <v-tab-item v-if="company.id != 'OaaRuxV6tA3nobp42xMq'">
            <WhiteLabel :companyId="company.id" />
          </v-tab-item>
          <v-tab-item v-if="company.id != 'OaaRuxV6tA3nobp42xMq'">
            <PaymentSettings :companyId="company.id" />
          </v-tab-item>
          <!-- <v-tab-item>
            <CompanyTrips :companyId="company.id" />
          </v-tab-item> -->
        </v-tabs-items>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import WhiteLabel from "../components/Company/WhiteLabel";
import Administrators from "../components/Company/Administrators";
import PaymentSettings from "../components/Company/PaymentSettings";
// import CompanyTrips from "../components/Company/CompanyTrips";

export default {
  name: "Company",
  components: { WhiteLabel, Administrators, PaymentSettings },
  props: ["companyId", "index"],
  data() {
    return {
      tab: null,
    };
  },
  computed: {
    company() {
      return this.$store.state.companies[this.$props.companyId];
    },
    companyPrivate() {
      return this.$store.state.companiesPrivate[this.$props.companyId];
    },
  },
  created() {
    console.log(this.$props);
  },
};
</script>
